<script>
	import { page } from '$app/stores';
	import SeoTags from '$lib/components/SeoTags.svelte';
</script>

<SeoTags
	data={{
		title: 'Page Not Found - Herd',
		description: 'The page you are looking for cannot be found.',
		keywords: 'Herd, page not found, error, 404',
		ogType: 'website',
		ogImage: '/social.png',
		canonicalUrl: $page.url.pathname
	}}
/>

<div class="container mx-auto px-4 py-12 flex flex-col items-center justify-center min-h-[60vh]">
	<div class="bg-surface-2 rounded-lg p-8 border border-surface-3 text-center max-w-2xl w-full">
		<h1 class="text-3xl font-bold text-gray-200 mb-3">🥾 Trail Not Found</h1>
		<h2 class="text-xl font-semibold text-gray-300 mb-6">
			Error {$page.status}: {$page.error?.message || 'Something went wrong'}
		</h2>

		<img src="/404.png" alt="404" class="w-48 mx-auto mb-6" />

		<p class="text-gray-400 text-lg mb-2">Lost your trail? We have plenty!</p>
		<p class="text-gray-400 mb-8">
			The path you're looking for has wandered off into the wilderness.
		</p>

		<div class="flex flex-col sm:flex-row justify-center gap-4">
			<a
				href="/trails"
				class="px-4 py-3 rounded-lg bg-gradient-to-r from-primary-500 to-accent-500 hover:from-primary-600 hover:to-accent-600 text-white font-medium inline-block"
			>
				Find a Trail
			</a>
			<a
				href="/"
				class="px-4 py-3 rounded-lg bg-surface-3 hover:bg-surface-4 text-white font-medium inline-block"
			>
				Back to Base Camp
			</a>
		</div>
	</div>
</div>

<style>
	@keyframes float {
		0% {
			transform: translateY(0px);
		}
		50% {
			transform: translateY(-10px);
		}
		100% {
			transform: translateY(0px);
		}
	}

	svg {
		animation: float 4s ease-in-out infinite;
	}
</style>
